import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { MeterIssueTypeJson } from '@/data/meters/MeterIssueJson.ts';

const CACHE_DURATION_MS = 60 * 60 * 1000;

export const useMeterIssueTypeStore = defineStore('meterIssueType', () => {
  const types = ref<MeterIssueTypeJson[] | null>(null);
  const fetchedAt = ref<number>(0);

  // A function rather than a computed: Date.now() is not reactive
  function isFresh(): boolean {
    return (
      types.value !== null && Date.now() - fetchedAt.value < CACHE_DURATION_MS
    );
  }

  function set(newTypes: MeterIssueTypeJson[]): void {
    types.value = newTypes;
    fetchedAt.value = Date.now();
  }

  function clear(): void {
    types.value = null;
    fetchedAt.value = 0;
  }

  return { types, isFresh, set, clear };
});
